import { useEffect, useState } from "react";
import { api, money } from "../lib/api";
import { PageHeader, Panel } from "../components/common";
import { BankScoreChart } from "../charts/Charts";
import { IssuerProfile } from "../components/IssuerProfile";

const rateColor = (r) => (r >= 0.6 ? "#CCFF00" : r >= 0.45 ? "#FFB800" : "#F87171");

export default function Banks() {
  const [banks, setBanks] = useState([]);
  const [sel, setSel] = useState(null);
  useEffect(() => { api.get("/banks").then((r) => { setBanks(r.data); setSel((s) => s || r.data[0]?.name); }); }, []);
  return (
    <div data-testid="banks-page">
      <PageHeader eyebrow="// issuer negotiation intelligence" title="Issuer Intel" />
      <div className="grid grid-cols-12 gap-6">
        <Panel title="Win-rate by issuer" className="col-span-12 xl:col-span-5"><BankScoreChart data={banks} /></Panel>
        <Panel title="Issuer playbook" className="col-span-12 xl:col-span-7">
          <div className="overflow-x-auto"><table className="w-full text-left min-w-[640px]" data-testid="banks-table">
            <thead><tr className="label-xs">{["Issuer", "Win %", "W / L / Open", "Recovered", "Avg days", "Negotiation tip"].map((h) => <th key={h} className="pb-3 font-normal pr-3">{h}</th>)}</tr></thead>
            <tbody>
              {banks.map((b) => (
                <tr key={b.id} onClick={() => setSel(b.name)} className={`border-b border-divider align-top cursor-pointer hover:bg-white/[0.03] transition-colors ${sel === b.name ? "bg-white/[0.04]" : ""}`} data-testid={`bank-row-${b.name.replace(/\s/g, "-").toLowerCase()}`}>
                  <td className="py-3 pr-3 text-sm whitespace-nowrap">{b.name}</td>
                  <td className="pr-3 font-mono text-sm font-bold tabular" style={{ color: rateColor(b.win_rate) }}>{Math.round(b.win_rate * 100)}%</td>
                  <td className="pr-3 font-mono text-xs text-white/45">{b.won} / {b.lost} / {b.open}</td>
                  <td className="pr-3 font-mono text-xs">{money(b.recovered)}</td>
                  <td className="pr-3 font-mono text-xs text-white/45">{b.avg_response_days}</td>
                  <td className="text-xs text-[#AAA] py-3">{b.tip}</td>
                </tr>
              ))}
            </tbody>
          </table></div>
        </Panel>
      </div>
      {sel && <IssuerProfile name={sel} />}
    </div>
  );
}
